import { h } from '@debbie/cortex/dist/index.js';
import { useInteractionCategories } from '@debbie/cortex/dist/interaction-categories/index.js';
import { useProcedures } from '@debbie/cortex/dist/procedures/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
const InteractionCategoriesPreview = (props) => {
    const proceduresLoader = useProcedures();
    const interactionCategoriesLoader = useInteractionCategories();
    const lang = useSelector((s) => s.lang);
    const procedures = h.hasData(proceduresLoader) ? proceduresLoader.data : null;
    const interactionCategories = h.hasData(interactionCategoriesLoader)
        ? interactionCategoriesLoader.data
        : null;
    const procedure = procedures?.find((p) => p.procedureId === props.procedureId);
    const category = interactionCategories?.find((c) => c.id === props.id);
    return (React.createElement("div", null, procedure && (React.createElement(React.Fragment, null,
        React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, category?.name),
        React.createElement("p", null,
            React.createElement(Link, { to: `/settings/workflows/procedures/${props.procedureId}` }, lang.procedureTitles[props.procedureId] || procedure.title))))));
};
export default InteractionCategoriesPreview;
//# sourceMappingURL=InteractionCategoryPreview.js.map